import { useLocation } from 'react-router-dom';

export function useIsCheckedRoute(path: string) {
  const location = useLocation();
  return location.pathname.includes(path);
}
